import request from '@/utils/request'

/**
 * C2C 多商家 / 搜索分析 / 资金中心 接口
 * 说明：管理端接口统一携带 X-Admin 头（由 request.js 使用后台 admin_token）
 */

// ============ 当前登录账号（角色 / 店铺 / 菜单） ============
export const getMerchantInfoApi = () => {
  return request.get('/merchant/info', { headers: { 'X-Admin': 1 } })
}

// ============ 商城端：各商家店铺与客服入口（公开） ============
export const getShopListApi = () => {
  return request.get('/merchant/shops')
}

// ============ 商城端：店铺主页（公开） ============
export const getShopDetailApi = (merchantId) => {
  return request.get('/merchant/shop', { params: { merchant_id: merchantId } })
}

// ============ 商城端：查看商家资质（需先安全验证） ============
// 安全验证：图形验证码 + 当前账号的登录密码（不发送短信），通过后返回短时令牌 { token, expire_in }
export const verifyQualificationApi = (password, captchaCode, captchaKey) => {
  return request.post('/merchant/qualverify', { password, captchaCode, captchaKey })
}

// 查看商家资质（需安全验证令牌）
export const getShopQualificationApi = (merchantId, token) => {
  return request.get('/merchant/qualification', {
    params: { merchant_id: merchantId, token }
  })
}

// 店铺页：该店铺在售商品（分页，每页 10 条）
export const getShopGoodsApi = (merchantId, page = 1) => {
  return request.get('/goods/list', { params: { merchantId, page } })
}

// ============ 商家端：店铺资料 / 商家资质维护 ============
export const getMyQualificationApi = () => {
  return request.get('/merchant/myqualification', { headers: { 'X-Admin': 1 } })
}

// 提交店铺资料 / 商家资质（个人 or 企业商家；提交后需超级管理员审核通过才在商城展示）
export const saveQualificationApi = (payload) => {
  return request.post('/merchant/savequalification', payload, { headers: { 'X-Admin': 1 } })
}

// ============ 超级管理员：商家资料审核 ============
// 查看某个商家提交的店铺资料 / 资质（审核用）
export const getMerchantShopDetailApi = (merchantId) => {
  return request.get('/merchant/shopdetail', {
    params: { merchant_id: merchantId },
    headers: { 'X-Admin': 1 }
  })
}

// 审核商家资料：action = approve（通过）/ reject（驳回，可填写原因）
export const auditMerchantApi = (merchantId, action, remark = '') => {
  return request.post('/merchant/audit', {
    merchant_id: merchantId,
    action,
    remark
  }, { headers: { 'X-Admin': 1 } })
}

// ============ 超级管理员：商家管理 ============
export const getMerchantListApi = (page = 1, pageSize = 20, keyword = '') => {
  return request.get('/merchant/list', {
    params: { page, pageSize, keyword },
    headers: { 'X-Admin': 1 }
  })
}

// 新增 / 编辑商家（payload 带 id 表示编辑）
export const saveMerchantApi = (payload) => {
  return request.post('/merchant/save', payload, { headers: { 'X-Admin': 1 } })
}

// 启用 / 禁用商家
export const toggleMerchantApi = (id) => {
  return request.post('/merchant/toggle', { id }, { headers: { 'X-Admin': 1 } })
}

// 删除商家
export const deleteMerchantApi = (id) => {
  return request.post('/merchant/delete', { id }, { headers: { 'X-Admin': 1 } })
}

// ============ 超级管理员：商城数据 / 商家数据 ============
export const getShopOverviewApi = (startDate, endDate) => {
  return request.get('/merchant/overview', {
    params: { start_date: startDate, end_date: endDate },
    headers: { 'X-Admin': 1 }
  })
}

export const getMerchantStatApi = (startDate, endDate) => {
  return request.get('/merchant/stat', {
    params: { start_date: startDate, end_date: endDate },
    headers: { 'X-Admin': 1 }
  })
}

// ============ 搜索分析 ============
// params: { start_date, end_date, keyword, page, pageSize, orderBy }
export const getSearchAnalyticsApi = (params) => {
  return request.get('/search/analytics', {
    params,
    headers: { 'X-Admin': 1 }
  })
}

// 清理搜索记录（仅超级管理员）：days > 0 只清理 N 天前
export const clearSearchLogsApi = (days = 0) => {
  return request.post('/search/clear', { days }, { headers: { 'X-Admin': 1 } })
}

// ============ 资金中心（商家货款） ============
// merchantId 仅超级管理员可传（查看指定商家）
export const getFundSummaryApi = (merchantId = 0) => {
  return request.get('/fund/summary', {
    params: { merchant_id: merchantId },
    headers: { 'X-Admin': 1 }
  })
}

// params: { page, pageSize, type, status, merchant_id }
export const getFundFlowsApi = (params) => {
  return request.get('/fund/flows', {
    params,
    headers: { 'X-Admin': 1 }
  })
}

// 手动触发结算同步（确认收货 / 超时 10 天到账）
export const syncFundApi = (merchantId = 0) => {
  return request.post('/fund/sync', { merchant_id: merchantId }, { headers: { 'X-Admin': 1 } })
}
